
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 18h2v2h-2zM28 16h2v2h-2zM14 6h2v2h-2zM16 22h-4v-6a2.002 2.002 0 00-2-2H4a2.002 2.002 0 00-2 2v6a2.002 2.002 0 002 2h6v4a2.002 2.002 0 002 2h4a2.002 2.002 0 002-2v-4a2.002 2.002 0 00-2-2zM4 22v-6h6v6zm8 6v-4h4v4zM28 30h-4a2.002 2.002 0 01-2-2v-4a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2zm-4-6v4h4v-4zM28 2h-6a2.002 2.002 0 00-2 2v6h-2a2.002 2.002 0 00-2 2v2a2.002 2.002 0 002 2h2a2.002 2.002 0 002-2v-2h6a2.002 2.002 0 002-2V4a2.002 2.002 0 00-2-2zM18 14v-2h2v2zm4-4V4h6v6zM8 10H4a2.002 2.002 0 01-2-2V4a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2zM4 4v4h4V4z"}}),_c('rect',{staticClass:"cls-1",attrs:{"data-name":"<Transparent Rectangle>","width":"32"}})])
          )
        }
      }
    